import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import FanFavouriteCard from 'Components/Cards/FanFavouriteCard';
import SkeletonFanFavouriteCard from 'Components/Utility/Skeleton/SkeletonFanFavouriteCard';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';


const FacetSearchScrollBreak = ({
  hits,
}) => {
  const sliderSettings = {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  };


  return (
    <div className="FacetSearchScrollBreak">
      {isEmpty(hits) &&
        <SiteSlider sliderSettings={sliderSettings}>
          {[...Array(12).keys()].map(fakeHit =>
            <SkeletonFanFavouriteCard
              key={fakeHit}
            />,
          )}
        </SiteSlider>
      }
      {!isEmpty(hits) &&
        <SiteSlider sliderSettings={sliderSettings}>
          {hits.slice(0, 12).map(hit =>
            <FanFavouriteCard
              key={hit.product_id}
              hit={hit}
            />,
          )}
        </SiteSlider>
      }
    </div>
  );
};


FacetSearchScrollBreak.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.object),
};

FacetSearchScrollBreak.defaultProps = {
  hits: [],
};


export default FacetSearchScrollBreak;
